import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, ShieldAlert } from 'lucide-react';
export function About() {
  const features = [{
    icon: <Target className="w-6 h-6 text-gold-400" data-id="element-41" />,
    title: 'Structural Analysis',
    description: 'We look beyond standard fundamentals to identify structural shifts in government policy, defense spending, and macro positioning.'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-gold-400" data-id="element-42" />,
    title: 'High-Conviction Portfolios',
    description: 'Our strategy clusters are designed to outperform through disciplined research, concentrated positioning, and event-driven catalysts.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-gold-400" data-id="element-43" />,
    title: 'Risk Management',
    description: 'Every strategy incorporates strict stop-loss rules, volatility-based position sizing, and systematic profit-taking mechanisms.'
  }];
  return <section id="about" className="py-24 md:py-32 bg-about-glow relative overflow-hidden" data-id="element-44">
      {/* Thin Vertical Line */}
      <div className="absolute left-6 md:left-12 top-24 h-[60%] w-[1px] bg-gradient-to-b from-gold-400/50 to-transparent hidden md:block" data-id="element-45"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 md:pl-24 relative z-10" data-id="element-46">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-48">
            <h2 className="text-xs tracking-[0.25em] text-gold-400/70 uppercase mb-4 flex items-center gap-3" data-id="element-49">
              <div className="w-8 h-[1px] bg-gold-400/40" data-id="element-50"></div>
              Investment Philosophy
            </h2>
            <h3 className="text-3xl md:text-5xl text-white leading-tight mb-6" data-id="element-51">
              <span className="font-light" data-id="element-52">Conviction-driven strategies.</span>
              <br data-id="element-53" />
              <span className="font-bold" data-id="element-54">Disciplined execution.</span>
            </h3>
            <p className="text-slate-400 text-lg leading-relaxed mb-8" data-id="element-55">
              Delta Street does not rely on passive market drift. We actively
              construct strategy clusters targeting specific market
              inefficiencies — isolating the variables that truly drive asset
              prices, from senatorial legislation and lobbying dollars to
              sector-specific momentum.
            </p>

            <div className="w-full h-[1px] bg-gradient-to-r from-gold-400/50 to-transparent mb-8" data-id="element-56"></div>

            <div className="grid grid-cols-2 gap-8" data-id="element-57">
              <div data-id="element-58">
                <div className="text-4xl font-bold text-white mb-2 font-mono" data-id="element-59">
                  11
                </div>
                <div className="text-sm text-slate-500 uppercase tracking-wider font-medium" data-id="element-60">
                  Strategy Clusters
                </div>
              </div>
              <div data-id="element-61">
                <div className="text-4xl font-bold text-white mb-2 font-mono" data-id="element-62">
                  Alpha
                </div>
                <div className="text-sm text-slate-500 uppercase tracking-wider font-medium" data-id="element-63">
                  Targeted Outperformance
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="grid gap-6" data-id="element-64">
            {features.map((feature, index) => <div key={index} className="relative p-6 bg-slate-900/30 border border-slate-800/60 flex gap-5 items-start group hover:border-slate-700/80 transition-colors" data-id="element-65">
                <div className="p-3 bg-gold-400/5 rounded-lg" data-id="element-66">
                  {feature.icon}
                </div>
                <div data-id="element-67">
                  <h4 className="text-lg font-semibold text-white mb-2" data-id="element-68">
                    {feature.title}
                  </h4>
                  <p className="text-slate-400 leading-relaxed" data-id="element-69">
                    {feature.description}
                  </p>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}